import { callApi } from "./fetchTools";
import {
  HTTP_METHOD_GET,
  HTTP_METHOD_POST,
  HTTP_METHOD_PUT,
} from "../utils/constant";
import apis from "../common/apis";
import { IResponsePaging } from "../models/base";
import { IProduct, IProductInfoToCart } from "../models/productModel";
import { IProductInventory } from "../models/IProductInventory";
import { getVoucherCode } from "../utils/helpers";

export const checkInventory = (info: any) => {
  return callApi<IProductInventory>(
    HTTP_METHOD_POST,
    apis.product_check_inventory,
    info
  );
};

export default {
  checkInventory: checkInventory,
  getProduct: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<any>(
      HTTP_METHOD_GET,
      `${
        apis.product_detail
      }${`${query.product_id}/${query.product_code}`}?path=${
        query.path
      }&voucher_code=${voucherCode}`,
      null
    );
  },
  // getProduct: (query: any) => {
  //   return callApi<any>(
  //     HTTP_METHOD_GET,
  //     `${apis.product_detail}${
  //       query.product_id && query.product_code
  //         ? `${query.product_id}/${query.product_code}`
  //         : ""
  //     }?path=${query.path}`,
  //     null
  //   );
  // },
  getRelatedProducts: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<any>(
      HTTP_METHOD_POST,
      `${apis.product_related_v3}${query.product_id}?path=${query.path}&voucher_code=${voucherCode}`,
      {}
    );
  },
  getBoughtTogetherProducts: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<any>(
      HTTP_METHOD_POST,
      `${apis.product_bought_together_v3}${query.product_id}/${query.product_code}?path=${query.path}&voucher_code=${voucherCode}`,
      {}
    );
  },
  getProductPromotion: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<any>(
      HTTP_METHOD_GET,
      `${apis.product_promotion}${query.code}?quantity=${query.quantity}&voucher_code=${voucherCode}`,
      null
    );
  },
  getProductsOfCategory: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_GET,
      `${apis.product_home_cat}?voucher_code=${voucherCode}`,
      query
    );
  },
  getProductsWish: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_GET,
      `${apis.product_wish}?voucher_code=${voucherCode}`,
      query
    );
  },
  getProductsWishV2: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_GET,
      `${apis.product_wish_v2}?voucher_code=${voucherCode}`,
      query
    );
  },
  editProductWish: (query: any) => {
    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_PUT,
      `${apis.product_wish}${query.code}`,
      query
    );
  },
  editProductWishV2: (query: any) => {
    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_PUT,
      `${apis.product_wish}`,
      query
    );
  },
  getProductsByCat: (query: any, id: string) => {
    const voucherCode = getVoucherCode();

    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_GET,
      `${apis.product_by_cat}${id}?voucher_code=${voucherCode}`,
      query
    );
  },
  getProductsByCategory: (query: any) => {
    const voucherCode = getVoucherCode();

    return callApi<any>(
      HTTP_METHOD_GET,
      `${apis.product_category}?voucher_code=${voucherCode}`,
      query
    );
  },
  getCategoryOptions: (query: any) => {
    return callApi<any>(HTTP_METHOD_GET, apis.category_options, query);
  },
  getProductSearch: (entity: any) => {
    const voucherCode = getVoucherCode();

    return callApi<IResponsePaging<IProduct[]>>(
      HTTP_METHOD_POST,
      `${apis.product_search}?offset=${entity.query.offset}&limit=${entity.query.limit}&voucher_code=${voucherCode}`,
      entity.data
    );
  },
  productInfoToCart: (
    product_id: string,
    product_code: string,
    parent_pro_id: string,
    cat_id_v2: string = ""
  ) => {
    const voucherCode = getVoucherCode();

    return callApi<IProductInfoToCart>(
      HTTP_METHOD_POST,
      apis.product_info_to_cart,
      {
        product_id,
        product_code,
        parent_pro_id,
        cat_id_v2,
        voucher_code: voucherCode,
      }
    );
  },
};
